import React from 'react';
import _ from 'lodash';

import {
  AppSettings_AssignedPermissionsTabDocument,
  AppSettings_AssignedPermissionsTab_UserDetailSectionDocument,
  useAppSettings_AssignedPermissionsTab_UserDetailSectionQuery,
  useUnassignRoleMutation
} from 'generated/graphql';



export interface IRoleAssignment {
  id: string;
  storeName: string;
  roleName: string;
  isGlobal: boolean;
}

export interface IData {
  assignedRoles: IRoleAssignment[];
}

export function useQuery(siteUserId: string) {
  const tuple = useAppSettings_AssignedPermissionsTab_UserDetailSectionQuery({
    variables: {
      siteUserId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        assignedRoles: _.map(tuple.data?.siteUser?.assignedRoles ?? [], role => ({
          id: role.id,
          roleName: role.roleTemplate.displayName,
          storeName: role.store?.name ?? '-',
          isGlobal: _.isNil(role.store)
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useUnassignRole(siteUserId: string) {
  const [fnMutate, tuple] = useUnassignRoleMutation({
    refetchQueries: [
      {
        query: AppSettings_AssignedPermissionsTabDocument,
        variables: {}
      },
      {
        query: AppSettings_AssignedPermissionsTab_UserDetailSectionDocument,
        variables: { siteUserId }
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (roleId: string) => {
      fnMutate({
        variables: {
          id: roleId
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
